import Swiper from 'swiper';
import {Scrollbar} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';

document.addEventListener('DOMContentLoaded', () => {
    let narrow = false;
    if (document.querySelector('.profile')) {
        narrow = true;
    }
    const swiper = new Swiper('.swiper', {
        modules: [Scrollbar],
        slidesPerView: 1,
        spaceBetween: 20,
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
        grabCursor: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            640: {
                slidesPerView: narrow ? 1 : 2,
                spaceBetween: 15,
            },
            1024: {
                slidesPerView: narrow ? 2 : 3,
                spaceBetween: 20,
            },
        },
    });
});
